module.exports = "https://s91588.cdn.ngenix.net/rating-frontend/_next/static/images/DownloadQr-79433aca8e9376546cf40c3361025e39.png";